import { useEffect, useState, useRef } from "react";
import UserBadge from "../../assets/images/svg-icons-material-io/badge_FILL0_wght400_GRAD0_opsz48.svg";
import useUserStore from "../../utils/storeApp";
import CallAPI from "../../services/apiCalls";
import AccountDetails from "./AccountDetails";
import $ from "jquery";

const DetailsMemberUser = () => {
  const { userRole, userToken, userSession, SetSharedObject, sharedObject } =
    useUserStore((state) => ({
      userRole: state.userRole,
      userToken: state.userToken,
      SetSharedObject: state.SetSharedObject,
      sharedObject: state.sharedObject,
      userSession: state.userSession,
    }));

  const formatPhoneNumber = (value) => {
    if (!value) return value;
    const phoneNumber = value.replace(/[^\d]/g, "");
    const phoneNumberLength = phoneNumber.length;
    if (phoneNumberLength < 4) return phoneNumber;
    if (phoneNumberLength < 7)
      return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6, 10)}`;
  };

  const [accountName, setAccountName] = useState("");
  const [addresses, setAddresses] = useState([]);
  const [domain, setDomain] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [fax, setFax] = useState("");
  const [userName, setUserName] = useState("");
  const [email, setEmail] = useState("");
  const [lastLoginTime, setLastLoginTime] = useState("");
  const [specialtyType, setSpecialtyType] = useState("");
  const [classification, setClassification] = useState("");
  const [specialization, setSpecialization] = useState("");
  const [orgList, setOrgList] = useState([]);
  const [directEmailList, setDirectEmailList] = useState([]);
  const [sharedEmailList, setSharedEmailList] = useState([]);
  const [idList, setIdList] = useState([]);
  const [processing, setProcessing] = useState(false);
  const [userEditDetails, setUserEditDetails] = useState(false);
  const [directTrust, setDirectTrust] = useState(false);

  useEffect(() => {
    if (sharedObject.accountDetailsFlag) {
      getUsers(userSession.sesuser_id);
    }
    return () => {
      SetSharedObject("accountDetailsFlag", false);
    };
  }, [sharedObject.accountDetailsFlag]);

  const getUsers = async (id) => {
    setProcessing(true);
    let call = "/admin/GetUserById?userId=" + id;
    const res = await CallAPI(call, false, "get", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      let det = res.data.data;
      setValues(det);
      setUserEditDetails(det.userContact);
      if (userRole === "USER") {
        getCustomerDetailsByVendorId(det.userContact.vendorId);
      } else {
        getCustomerDetails(det.userContact.vendorId);
      }

      await SetSharedObject("specialties", det.userContact.specialties);
      await SetSharedObject("selectedUser", det.userContact);
      await SetSharedObject("codes", det.codes);
      setProcessing(false);
    } else if (res.status === "SERVERERROR") {
      setProcessing(false);
    }
  };
  const getCustomerDetailsByVendorId = async (vendorId) => {
    setProcessing(true);
    let call = "/admin/GetVendorByID?userId=" + vendorId;
    const res = await CallAPI(call, false, "get", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      let det = res.data.data;
      setDirectTrust(det.directTrust);
      setProcessing(false);
    } else if (res.status === "SERVERERROR") {
      setProcessing(false);
    }
  };
  const getCustomerDetails = async (vendorId) => {
    var obj = sharedObject.vendorsObj;
    for (var i = 0; i < obj.length; i++) {
      var c = obj[i];
      if (c.id === vendorId) {
        setDirectTrust(c.directTrust);
      }
    }
  };

  const setValues = (vals) => {
    var details = vals.userDet;
    var contact = vals.userContact;
    var org = vals.userOrg;
    var emails = vals.userEmails;
    setAddresses(contact.addresses);
    if (contact?.addresses[0]?.fax != null) {
      setFax(contact?.addresses[0]?.fax);
    } else {
      setFax("");
    }

    if (contact?.addresses[0]?.phone != null) {
      setPhoneNumber(contact?.addresses[0]?.phone);
    } else {
      setPhoneNumber("");
    }
    setUserName(details.userName);
    setEmail(contact.contactEmail);
    setDomain(contact.domainName);
    setLastLoginTime(contact.lastLoginTime);
    setSpecialtyType(contact?.specialties[0]?.type);
    setClassification(contact?.specialties[0]?.classification);
    setSpecialization(contact?.specialties[0]?.specialization);
    setAccountName(details.name);
    var tempSharedList = [];
    var tempDirectList = [];
    for (var i = 0; i < emails.length; i++) {
      if (emails[i].userEmailTypeString === "Shared") {
        tempSharedList.push(emails[i]);
      } else {
        tempDirectList.push(emails[i]);
      }
    }
    setDirectEmailList(tempDirectList);
    setSharedEmailList(tempSharedList);
    setIdList(contact.iDs);
    setOrgList(org);
  };
  const handleEdit = () => {
    getUsers(userSession.sesuser_id);
  };

  const [loadingText, setLoadingText] = useState("Loading...");
  useEffect(() => {
    let timer;
    if (processing) {
      timer = setTimeout(() => {
        setLoadingText("Working on it...");
      }, 10000);
    } else {
      setLoadingText("Loading...");
    }

    return () => clearTimeout(timer);
  }, [processing]);

  const firstFocusRef = useRef(null);
  useEffect(() => {
    const modalEl = document.getElementById("detailsMemberUserModal");
    if (!modalEl) return;
    const onShown = () => setTimeout(() => firstFocusRef.current?.focus(), 50);
    modalEl.addEventListener("shown.bs.modal", onShown);
    return () => modalEl.removeEventListener("shown.bs.modal", onShown);
  }, []);

  const CloseModal = () => {
    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }

    $("#detailsMemberUserModal").modal("hide");
  };

  return (
    <div className="DetailsMemberUser">
      <div
        className="modal fade"
        id="detailsMemberUserModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="detailsMemberUserModalTitle"
        aria-describedby="detailsMemberUserModalDesc"
        data-backdrop="static"
        aria-modal="true"
      >
        <div className="modal-dialog modal-dialog-slideout">
          <div className="modal-content">
            <div className="modal-header">
              <h2
                className="modal-title spacer-inline text-size3"
                id="detailsMemberUserModalTitle"
              >
                Details
              </h2>
              <p id="detailsMemberUserModalDesc" className="sr-only">
                View member user details and account information.
              </p>
              <button
                type="button"
                className="close"
                aria-label="Close Member Details Modal"
                onClick={CloseModal}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <div className="modal-body">
              <div className="modal-content-body container">
                <div className="details-header blk-clr">
                  <img
                    className="spacer-margin7"
                    src={UserBadge}
                    alt=""
                    aria-hidden="true"
                  />
                  <div className="text-size6 ft-wt blk-clr">{accountName}</div>
                  <div className="sp-margin1">
                    <button
                      type="button"
                      className="btn btn-link p-0"
                      ref={firstFocusRef}
                      aria-label="Edit account details"
                      aria-haspopup="dialog"
                      onClick={(el) => {
                        $("#EditAccountModal").modal("show");
                        SetSharedObject("hidePermission", true);
                        el.preventDefault();
                      }}
                    >
                      <i
                        className="bi bi-pencil-square sp-margin5"
                        aria-hidden="true"
                      ></i>
                      Edit
                    </button>
                  </div>
                </div>
                <section
                  className="field-wrapper"
                  aria-label="Contact Information"
                >
                  <dl className="sp-mx7">
                    <dt>Address:</dt>
                    <dd className="sp-margin5 spacer-inline">
                      {addresses?.length > 0 ? (
                        <>
                          <span>{addresses[0].firstLine} </span>
                          <span>{addresses[0].secondLine}, </span>
                          <span>{addresses[0].city}, </span>
                          <span>{addresses[0].state} </span>
                          <span>{addresses[0].postalCode}</span>
                        </>
                      ) : null}
                    </dd>
                  </dl>
                  <dl>
                    <dt>Phone:</dt>{" "}
                    <dd className="sp-margin5">
                      {phoneNumber
                        ? formatPhoneNumber(phoneNumber.substring(0, 10))
                        : null}
                    </dd>
                    <dt>Ext:</dt>{" "}
                    <dd>
                      {phoneNumber
                        ? phoneNumber.substring(10, phoneNumber.length)
                        : null}
                    </dd>
                    <br />
                    <dt>Fax:</dt>{" "}
                    <dd className="sp-margin5">
                      {phoneNumber
                        ? formatPhoneNumber(fax.substring(0, 10))
                        : null}
                    </dd>
                    <dt>Ext:</dt>{" "}
                    <dd className="sp-margin5">
                      {phoneNumber ? fax.substring(10, fax.length) : null}
                    </dd>
                  </dl>
                </section>
                <hr />
                {/*User Info*/}
                <section
                  className="field-wrapper"
                  aria-label="User information"
                >
                  <dl className="sp-mx7">
                    <dt>Username:</dt>
                    <dd className="sp-margin12"> {userName.split("|")[0]} </dd>
                    <br />
                    <dt>Contact Email:</dt>
                    <dd className="word-set sp-margin12"> {email} </dd>
                    <br />
                    <dt>Domain:</dt>
                    <dd className="word-set sp-margin12">{domain}</dd>
                    <br />
                    <dt>Last Login:</dt>
                    <dd className="sp-margin12">{lastLoginTime}</dd>
                    <br />
                    <dt>Direct Trust:</dt>
                    <dd className="sp-margin12">
                      {directTrust ? "Yes" : "No"}
                    </dd>
                  </dl>
                </section>
                {userRole !== "SES ADMINISTRATOR" &&
                userRole !== "SYSTEMADMINISTRATOR" ? (
                  <>
                    <section
                      className="field-wrapper"
                      aria-labelledby="specialtyHeading"
                    >
                      <span className="custom-label" id="specialtyHeading">
                        Specialty
                      </span>
                      <div className="sub-catg">
                        <dl className="sp-mx7">
                          <dt>Type:</dt>
                          <dd>{specialtyType}</dd>
                          <br />
                          <dt>Classification:</dt>
                          <dd>{classification}</dd>
                          <br />
                          <dt>Specialization:</dt>
                          <dd>{specialization}</dd>
                        </dl>
                      </div>
                    </section>
                    {/*Org Info*/}
                    <section aria-labelledby="organizationTitle">
                      <div className="label-divider">
                        <h6
                          className="sp-pad9 spacer-inline"
                          id="organizationTitle"
                        >
                          Organizations
                        </h6>
                      </div>
                      <div className="field-wrapper o-flow">
                        <table aria-label="Organizations">
                          <caption className="sr-only">
                            Organizations and roles associated with your account
                          </caption>
                          <thead>
                            <tr>
                              <th scope="col">Name</th>
                              <th scope="col">Role</th>
                            </tr>
                          </thead>
                          <tbody>
                            {orgList?.map((orgItem, index) => {
                              return (
                                <tr>
                                  <td className="word-set">
                                    {orgItem.organizationName}
                                  </td>
                                  <td className={index}>{orgItem.roleName} </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                    </section>

                    {/*Direct Email Info*/}
                    <section aria-labelledby="directEmailTitle">
                      <div className="label-divider">
                        <h6 className="sp-pad9" id="directEmailTitle">
                          Direct Email
                        </h6>
                      </div>
                      {directEmailList?.length <= 0 ? (
                        <div className="field-wrapper sub-catg" role="status">
                          You currently do not have any emails.
                        </div>
                      ) : (
                        <div className="field-wrapper o-flow">
                          <table aria-label="Direct emails">
                            <caption className="sr-only">
                              Direct email addresses assigned to your account
                            </caption>
                            <thead>
                              <tr>
                                <th scope="col">Email</th>
                                <th scope="col">Purpose</th>
                              </tr>
                            </thead>
                            <tbody>
                              {directEmailList?.map((emails, index) => {
                                return (
                                  <tr key={index}>
                                    <td className="word-set">
                                      {emails.directEmailAddress}
                                    </td>
                                    <td className={index}>
                                      {emails.emailPurposeTypeString}
                                    </td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>
                        </div>
                      )}
                    </section>

                    {/*Shared Emails Info*/}
                    <section aria-labelledby="sharedOrgEmailTitle">
                      <div className="label-divider">
                        <h6 className="sp-pad9" id="sharedOrgEmailTitle">
                          Assigned To Organization Email
                        </h6>
                      </div>
                      {sharedEmailList?.length <= 0 ? (
                        <div
                          className="field-wrapper sub-catg"
                          aria-live="polite"
                          aria-atomic="true"
                          role="alert"
                        >
                          There are no organization emails assigned to you.
                        </div>
                      ) : (
                        <div className="field-wrapper o-flow">
                          <table>
                            <caption className="sr-only">
                              Organization email addresses you have been
                              assigned to that you can share with other members.
                            </caption>
                            <thead>
                              <tr>
                                <th scope="col">Email</th>
                                <th scope="col">Purpose</th>
                              </tr>
                            </thead>
                            <tbody>
                              {sharedEmailList?.map((emails, index) => {
                                return (
                                  <tr>
                                    <td className="word-set">
                                      {emails.directEmailAddress}
                                    </td>
                                    <td className={index}>
                                      {emails.emailPurposeTypeString}
                                    </td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>
                        </div>
                      )}
                    </section>

                    {/*ID Info*/}
                    <section aria-labelledby="idTitle">
                      <div className="label-divider">
                        <h6 className="sp-pad9" id="idTitle">
                          ID
                        </h6>
                      </div>
                      {sharedEmailList?.length <= 0 ? (
                        <div className="field-wrapper sub-catg">
                          There are currently no IDs.
                        </div>
                      ) : (
                        <div className="field-wrapper">
                          <table
                            className="o-flow"
                            aria-label="Identity documents"
                          >
                            <caption className="sr-only">
                              Identity documents associated with your account
                            </caption>
                            <thead>
                              <tr>
                                <th scope="col">Type</th>
                                <th scope="col">Value</th>
                                <th scope="col">Issuing Authority</th>
                              </tr>
                            </thead>
                            <tbody>
                              {idList?.map((id, index) => {
                                return (
                                  <tr>
                                    <td> {id.idTypeString} </td>
                                    <td> {id.value} </td>
                                    <td> {id.issuingAuthority} </td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>
                        </div>
                      )}
                    </section>
                  </>
                ) : null}
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-outline-secondary"
                  onClick={CloseModal}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {processing && (
        <div
          className="loader-container"
          role="status"
          aria-live="polite"
          aria-atomic="true"
          aria-labelledby="details-member-loader"
        >
          <div className="spinner" aria-hidden="true"></div>
          <div className="loading-text" id="details-member-loader">
            {loadingText}
          </div>
        </div>
      )}
      <AccountDetails
        closeEdit={(el) => handleEdit()}
        userEditDetails={userEditDetails}
      />
    </div>
  );
};

export default DetailsMemberUser;
